package top.wcpe.allincore.dsl.compiler.parse

import top.wcpe.allincore.dsl.compiler.ast.ModelAst
import top.wcpe.allincore.dsl.compiler.ast.NamespacedStateAst
import top.wcpe.allincore.dsl.compiler.ast.ParamsAst
import top.wcpe.allincore.dsl.compiler.ast.StateAst
import top.wcpe.allincore.dsl.compiler.diag.DslError
import top.wcpe.allincore.dsl.compiler.lex.TokenType

/** 解析 v2 `model { ... }` 块。 */
internal class ModelBlockParser(private val p: Parser) {

    fun parse(component: Boolean = false): ModelAst {
        val tok = p.expect(TokenType.IDENTIFIER, "model 缺失")
        p.expect(TokenType.LBRACE, "model 缺少 '{'")
        p.skipNewlines()
        var params: ParamsAst? = null
        var state: StateAst? = null
        var derived: top.wcpe.allincore.dsl.compiler.ast.DerivedAst? = null
        val sessions = mutableListOf<NamespacedStateAst>()
        val persists = mutableListOf<NamespacedStateAst>()
        val stateParser = StateBlockParser(p)
        while (!p.check(TokenType.RBRACE) && !p.check(TokenType.EOF)) {
            when (p.current().type) {
                TokenType.IDENTIFIER -> {
                    when (p.current().lexeme) {
                        "params" -> {
                            if (component) {
                                p.fail(DslError.AUI_V2_COMPONENT_MODEL_FORBIDS_GLOBAL_SCOPE, p.current().position, "params")
                            }
                            if (params != null) p.fail("params 块只能声明一次", p.current().position)
                            params = stateParser.parseParams()
                        }
                        else -> p.fail("model 块内不识别的 token: '${p.current().lexeme}'", p.current().position)
                    }
                }
                TokenType.KW_STATE -> {
                    if (state != null) p.fail("model.state 块只能声明一次", p.current().position)
                    state = stateParser.parseModelState()
                }
                TokenType.KW_SESSION -> {
                    if (component) {
                        p.fail(DslError.AUI_V2_COMPONENT_MODEL_FORBIDS_GLOBAL_SCOPE, p.current().position, "session")
                    }
                    sessions += stateParser.parseModelScopedState(TokenType.KW_SESSION, "session")
                }
                TokenType.KW_PERSIST -> {
                    if (component) {
                        p.fail(DslError.AUI_V2_COMPONENT_MODEL_FORBIDS_GLOBAL_SCOPE, p.current().position, "persist")
                    }
                    persists += stateParser.parseModelScopedState(TokenType.KW_PERSIST, "persist")
                }
                TokenType.KW_DERIVED -> {
                    if (derived != null) p.fail("model.derived 块只能声明一次", p.current().position)
                    derived = stateParser.parseModelDerived()
                }
                else -> p.fail("model 块内不识别的 token: '${p.current().lexeme}'", p.current().position)
            }
            p.skipNewlines()
        }
        val close = p.expect(TokenType.RBRACE, "model 缺少 '}'")
        return ModelAst(
            params = params,
            state = state,
            sessionNamespaces = sessions,
            persistNamespaces = persists,
            derived = derived,
            position = p.completePosition(tok.position, close),
        )
    }
}
